module.exports = __webpack_public_path__ + "media/offers_icons/dostawcze-white-0cab4295.svg";